/**
 * HPE B2C 4059: Partner-specific "store in store" experience
 *
 * Creates a partner-specific shopping experience triggered by URL parameter.
 * When users arrive with selectedPartner parameter, they only see that partner
 * throughout their session.
 *
 * @version 1.0.0
 * @author FunnelEnvy Dev Pipeline
 */

(function () {


    const CONFIG = {
        experimentId: '4059-partner-store-in-store',
        storageKey: 'fe_hpe_selected_partner',
        urlParam: 'selectedPartner',
        campaignPagePattern: '/products/campaign/skuListingPage/',// 'selectedPartner',// '/products/campaign/skuListingPage/15351',
        productPagePattern: '/p/',
        logPrefix: '[HPE-4059]'
    };

    const SelectorsDictionary = {
        CampaignPage: {
            ShopByResellerBtn: 'button',
            ProductLinks: 'h2.hpe-product-list__name a, a.hpe-product-list__name',
            FacetButtons: 'complementary button, aside button, [role="complementary"] button',
            ResellerDropdowns: '.hpeit-reseller-dropdown',
            ResellerOptionsList: '.hpeit-reseller-dropdown-options,div.hpeit-reseller-dropdown-input',
            ResellerOptionItem: 'li[data-resellername]',
            ResellerFacet: '.facetID_hpeReseller',
            ProductResellerContainer: '.hpe-sku-reseller',
            ProductButtonContainer: '.hpe-product-list__button',
            ProductCustomizeContainer: '.hpeit-config-cta2.nonhpefsoffer_',
            ProductAddToCartBtn: '.add-cart-btn'
        },
        ProductPage: {
            ResellerDropdown: 'select[name*="reseller"], select[id*="partner"], .reseller-dropdown, div.hpeit-reseller-dropdown, .partner-select',
            ResellerOptions: '[data-resellername], option',
            PriceContainer: '.hpe-pricing-section, .hpe-price-container, .hpe-buy-now-price, [class*="price"]',
            AddToCartBtn: 'button[seleniumtest="addToCart"], button:contains("Add to cart"), .hpe-button:contains("cart")',
            CustomizeBtn: 'button:contains("Customize"), a:contains("Customize"), [class*="customize"]',
            QuoteBtn: 'button:contains("Request a quote"), button[class*="quote"]'
        }
    };


    /**
     * Utility: Log messages with experiment prefix
     */
    function log(message, data) {
        if (window.feHPEB2C && window.feHPEB2C.log) {
            window.feHPEB2C.log(`${CONFIG.logPrefix} ${message}`, data || {});
        }
    }

    /**
     * Utility: Get URL parameter value
     */
    function getUrlParameter(param) {
        try {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(param);
        } catch (error) {
            log('Error getting URL parameter', {param, error: error.message});
            return null;
        }
    }

    /**
     * Utility: Set sessionStorage value
     */
    function setSessionStorage(key, value) {
        try {
            const sanitized = value
                .replace(/[<>"']/g, '')
                .substring(0, 100);

            sessionStorage.setItem(key, sanitized);

            log('SessionStorage set successfully', {key, value: sanitized});
            return true;
        } catch (error) {
            log('Error setting sessionStorage', {key, error: error.message});
            return false;
        }
    }

    /**
     * Utility: Get sessionStorage value
     */
    function getSessionStorage(key) {
        try {
            return sessionStorage.getItem(key);
        } catch (error) {
            log('Error getting sessionStorage', {key, error: error.message});
            return null;
        }
    }

    /**
     * Check if we're on a campaign landing page
     */
    function isCampaignPage() {
        return window.location.pathname.includes(CONFIG.campaignPagePattern);
    }

    /**
     * Check if we're on a product detail page
     */
    function isProductPage() {
        return window.location.pathname.includes(CONFIG.productPagePattern);
    }


    /**
     * Update URL to apply reseller filter
     */
    function applyResellerFilter(partnerName) {
        try {
            const url = new URL(window.location.href);

            url.searchParams.delete(CONFIG.urlParam);

            const filterValue = `hpeReseller:${partnerName}`;
            const existingQ = url.searchParams.get('q');

            if (existingQ) {
                if (!existingQ.includes(filterValue)) {
                    url.searchParams.set('q', `${existingQ}:${filterValue}`);
                }
            } else {
                url.searchParams.set('q', `:relevance:${filterValue}`);
            }
            window.history.pushState({}, '', url.toString());
            log('Reseller filter applied', {partnerName, url: url.toString()});

            return true;
        } catch (error) {
            log('Error applying reseller filter', {partnerName, error: error.message});
            return false;
        }
    }

    /**
     * Hide "Shop by Reseller" facet in sidebar
     */
    function hideResellerFacet() {
        try {
            const facet = jQuery(SelectorsDictionary.CampaignPage.ResellerFacet);

            if (facet.length === 0) {
                log('Reseller facet not found on page');
                return false;
            }

            facet.addClass('fe-4059-hidden');

            log('Reseller facet hidden', {success: true, facetCount: facet.length});
            return true;
        } catch (error) {
            log('Error hiding reseller facet', {error: error.message});
            return false;
        }
    }

    function compareStringsThatMightBeUrlEncoded(str1, str2) {
        const decode = (str) => {
            try {
                return decodeURIComponent(str.replace(/\+/g, ' '));
            } catch (e) {
                return str;
            }
        }
        log('Comparing strings', {str1, str2},decode(str1), decode(str2) );
        return decode(str1).toLowerCase() === decode(str2).toLowerCase();
    }

    /**
     * Detect the redesigned page layout used on uatc.
     * Old layout (prod): .hpeit-reseller-dropdown is wrapped in .hpe-sku-reseller.
     * New layout (uatc): no .hpe-sku-reseller wrapper; dropdown is a direct sibling
     *                    of the "Buy from:" label inside the product container.
     * The new layout's resellerDropdownOptionsClick only processes a selection when
     * the dropdown is already open (has the 'active' class), so we must open it first.
     */
    function isNewPageLayout() {
        return jQuery(SelectorsDictionary.CampaignPage.ProductResellerContainer).length === 0;
    }

    /**
     * Select partner in all product dropdowns on campaign page
     * Also hides product elements if partner is not available
     */
    function selectPartnerInDropdowns(partnerName) {
        try {
            const dropdowns = jQuery(SelectorsDictionary.CampaignPage.ResellerDropdowns);

            if (dropdowns.length === 0) {
                log('No reseller dropdowns found on page');
                return 0;
            }

            let selectedCount = 0;
            let hiddenCount = 0;
            let productsHidden = 0;

            dropdowns.each(function () {
                const dropdown = jQuery(this);

                // Find the UL options list specifically (has data-productcode attribute)
                let optionsList = dropdown.find('.hpeit-reseller-dropdown-options');

                if (optionsList.length === 0) {
                    log('No options list found in dropdown');
                    return;
                }

                // Get product code from the options list data attribute
                let productCode = optionsList.attr('data-productcode');

                // If not found, try to extract from the ID (e.g., "hpeit-reseller-options_H33XSE")
                if (!productCode) {
                    const listId = optionsList.attr('id');
                    if (listId) {
                        const match = listId.match(/_([A-Z0-9-]+)$/i);
                        if (match) {
                            productCode = match[1];
                        }
                    }
                }

                const allOptions = optionsList.find(SelectorsDictionary.CampaignPage.ResellerOptionItem);

                if (allOptions.length === 0) {
                    log('No reseller options found in dropdown', {productCode});
                    return;
                }

                log('Processing dropdown', {
                    productCode,
                    totalOptions: allOptions.length,
                    partnerName
                });

                // Filter options to find matching partner
                const matchingOptions = allOptions.filter(function () {
                    const resellerName = jQuery(this).attr('data-resellername');
                    return resellerName && compareStringsThatMightBeUrlEncoded(resellerName, partnerName);
                });

                log('Matching options found', {
                    productCode,
                    matchingCount: matchingOptions.length,
                    totalCount: allOptions.length
                });

                // Hide non-matching options
                allOptions.not(matchingOptions).addClass('fe-4059-hidden');
                hiddenCount += allOptions.length - matchingOptions.length;

                // Check if only one option is visible and add class to hide caret
                if (matchingOptions.length === 1) {
                    dropdown.addClass('fe-4059-single-option');
                } else {
                    dropdown.removeClass('fe-4059-single-option');
                }

                // If partner found, select it; otherwise hide transaction element
                if (matchingOptions.length > 0) {
                    // New page layout (uatc): resellerDropdownOptionsClick only
                    // processes a selection when the dropdown is already open.
                    // Open it first so the subsequent option click registers.
                    if (isNewPageLayout()) {
                        dropdown.find('.hpeit-reseller-dropdown-input').trigger('click');
                    }
                    matchingOptions.first().trigger('click');
                    selectedCount++;
                    log('Partner selected in dropdown', {
                        partnerName,
                        resellerName: matchingOptions.first().attr('data-resellername'),
                        productCode
                    });
                } else {
                    // NO matching partner found - hide the entire transaction section
                    log('No partner match found, hiding transaction element', {
                        partnerName,
                        productCode
                    });

                    if (productCode) {
                        let transactionHidden = false;

                        // Try multiple selector strategies to find the transaction wrapper
                        const selectors = [
                            `#hpeit-transactionalCTA_${productCode}`,                        // Standard format
                            `div[id="hpeit-transactionalCTA_${productCode}"]`,               // Explicit div with ID
                            `div.price-cta-section[id*="${productCode}"]`,                   // Price CTA section with product code in ID
                            `div[id^="hpeit-transactionalCTA_"][id$="${productCode}"]`,      // Starts with prefix, ends with product code
                            `div.instant-pricing-section-hide${productCode}`                 // Alternative class pattern
                        ];

                        for (let i = 0; i < selectors.length && !transactionHidden; i++) {
                            const selector = selectors[i];
                            const transactionEl = jQuery(selector);

                            if (transactionEl.length > 0) {
                                transactionEl.addClass('fe-4059-hidden');
                                transactionHidden = true;
                                productsHidden++;
                                log('Transaction element hidden successfully', {
                                    productCode,
                                    selector,
                                    selectorIndex: i
                                });
                            }
                        }

                        if (!transactionHidden) {
                            log('Transaction element not found with any selector', {
                                productCode,
                                triedSelectors: selectors
                            });

                            // As a last resort, try to find it relative to the dropdown
                            const closestSection = dropdown.closest('.price-cta-section, [id^="hpeit-transactionalCTA_"]');
                            if (closestSection.length > 0) {
                                closestSection.addClass('fe-4059-hidden');
                                transactionHidden = true;
                                productsHidden++;
                                log('Transaction element hidden via DOM traversal', {productCode});
                            } else {
                                log('Could not find transaction element via any method', {productCode});
                            }
                        }
                    } else {
                        log('Cannot hide transaction element - no product code found');
                    }
                }
            });

            log('Partner selection complete', {
                partnerName,
                totalDropdowns: dropdowns.length,
                selectedCount,
                hiddenCount,
                productsHidden
            });

            return selectedCount;
        } catch (error) {
            log('Error selecting partner in dropdowns', {partnerName, error: error.message});
            return 0;
        }
    }


    /**
     * Campaign Landing Page: Main logic
     */
    function handleCampaignPage() {

        try {
            let partnerParam = getUrlParameter(CONFIG.urlParam);

            if (!partnerParam) {
                // Fallback for uatc: the new page layout performs a full reload
                // after applyResellerFilter (instead of a pushState-only update),
                // which clears sessionStorage. The partner name is still embedded
                // in the 'q' URL parameter as 'hpeReseller:<name>' — extract it.
                const qParam = getUrlParameter('q');
                if (qParam) {
                    const marker = 'hpeReseller:';
                    const idx = qParam.indexOf(marker);
                    if (idx >= 0) {
                        const raw = qParam.substring(idx + marker.length).split(':')[0];
                        partnerParam = decodeURIComponent(raw.replace(/\+/g, ' '));
                        log('Partner extracted from q URL parameter', {partner: partnerParam});
                    }
                }
            }

            if (!partnerParam) {
                log('No partner parameter found on campaign page');
                return;
            }

            log('Partner parameter detected', {partner: partnerParam});

            setSessionStorage(CONFIG.storageKey, partnerParam);

            // Skip if the reseller filter is already in the URL. On uatc the page
            // fully reloads after applyResellerFilter; calling it again would cause
            // another reload loop.
            const existingQ = getUrlParameter('q') || '';
            if (!existingQ.includes(`hpeReseller:${partnerParam}`)) {
                applyResellerFilter(partnerParam);
            }

        } catch (error) {
            log('Error in campaign page logic', {error: error.message});
        }
    }

    /**
     * Product Page: Filter and select partner in standard dropdown
     */
    function filterPartnerDropdown(selectedPartner) {
        try {
            const dropdowns = jQuery(SelectorsDictionary.ProductPage.ResellerDropdown);

            if (dropdowns.length === 0) {
                log('No partner dropdown found on page');
                return false;
            }

            let partnerFound = false;

            dropdowns.each(function () {
                const dropdown = jQuery(this);
                const allOptions = dropdown.find('option');

                // Filter options to find matching partner
                const matchingOptions = allOptions.filter(function () {
                    const option = jQuery(this);
                    const optionText = option.text().trim();
                    const optionValue = option.val();
                    const dataReseller = option.attr('data-resellername');

                    // Skip empty options
                    if (!optionValue) {
                        return false;
                    }

                    return optionText.toLowerCase().includes(selectedPartner.toLowerCase()) ||
                        optionValue.toLowerCase().includes(selectedPartner.toLowerCase()) ||
                        (dataReseller && dataReseller.toLowerCase().includes(selectedPartner.toLowerCase()));
                });

                // Hide non-matching options
                allOptions.not(matchingOptions).each(function () {
                    if (jQuery(this).val()) {
                        jQuery(this).remove();//addClass('fe-4059-hidden');
                    }
                });

                // Select matching partner if found
                if (matchingOptions.length > 0) {
                    dropdown.val(matchingOptions.first().val());
                    partnerFound = true;
                    log('Partner selected in standard dropdown', {
                        selectedPartner,
                        selectedValue: matchingOptions.first().val()
                    });
                }
            });

            log('Partner dropdown filtering complete', {selectedPartner, partnerFound});
            return partnerFound;

        } catch (error) {
            log('Error filtering partner dropdown', {error: error.message});
            return false;
        }
    }


    /**
     * Track which dropdowns have already been processed by product code
     */
    const processedDropdowns = new Set();

    /**
     * Process dropdowns that haven't been processed yet
     */
    function processNewDropdowns(selectedPartner) {
        try {
            const dropdowns = jQuery(SelectorsDictionary.CampaignPage.ResellerDropdowns);

            if (dropdowns.length === 0) {
                log('No dropdowns found on page');
                return;
            }

            log('Found dropdowns on page', {totalCount: dropdowns.length});

            let newDropdownsFound = false;
            const newProductCodes = [];

            dropdowns.each(function() {
                const dropdown = jQuery(this);

                // Get product code from the options list
                const optionsList = dropdown.find('.hpeit-reseller-dropdown-options');
                let productCode = optionsList.attr('data-productcode');

                // Fallback to extracting from ID
                if (!productCode) {
                    const listId = optionsList.attr('id');
                    if (listId) {
                        const match = listId.match(/_([A-Z0-9-]+)$/i);
                        if (match) {
                            productCode = match[1];
                        }
                    }
                }

                // Use product code as the unique identifier
                if (productCode && !processedDropdowns.has(productCode)) {
                    newDropdownsFound = true;
                    processedDropdowns.add(productCode);
                    newProductCodes.push(productCode);
                    log('New dropdown detected', {productCode});
                }
            });

            if (newDropdownsFound) {
                log('Processing new dropdowns', {
                    count: newProductCodes.length,
                    productCodes: newProductCodes
                });
                selectPartnerInDropdowns(selectedPartner);
            } else {
                log('All dropdowns already processed', {
                    processedCount: processedDropdowns.size
                });
            }
        } catch (error) {
            log('Error processing new dropdowns', {error: error.message});
        }
    }

    /**
     * Product Page: Main logic
     */
    function handleProductPage() {

        try {
            const selectedPartner = getSessionStorage(CONFIG.storageKey);

            if (!selectedPartner) {
                log('No partner session data found on product page');
                return;
            }

            log('Partner session data detected', {partner: selectedPartner});

            // Handle standard select dropdowns (if they exist)
            filterPartnerDropdown(selectedPartner);

            // Hide reseller facet
            hideResellerFacet();

            // Process any dropdowns already on the page
            processNewDropdowns(selectedPartner);

            // Set up MutationObserver to watch for dynamically loaded dropdowns
            // This is crucial for service sections that load via AJAX
            const observer = new MutationObserver(() => {
                processNewDropdowns(selectedPartner);
            });

            // Observe the entire document body for new elements
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });

            log('MutationObserver set up to watch for dynamic dropdowns');

            // Also retry periodically for the first 10 seconds to catch timing issues
            let retryCount = 0;
            const maxRetries = 20; // 20 attempts over 10 seconds
            const retryInterval = setInterval(() => {
                processNewDropdowns(selectedPartner);
                retryCount++;

                if (retryCount >= maxRetries) {
                    clearInterval(retryInterval);
                    log('Stopped periodic retry checks');
                }
            }, 500);

        } catch (error) {
            log('Error in product page logic', {error: error.message});
        }
    }

    /**
     * Main initialization function
     */
    function init() {
        try {

            const bodyClass = `fe-hpe-${CONFIG.experimentId.split('-')[0]}`;

            if (isCampaignPage()) {
                jQuery('body').addClass(bodyClass);
                log('Detected campaign page');
                handleCampaignPage();
                handleProductPage();
            } else if (isProductPage()) {
                jQuery('body').addClass(bodyClass);
                log('Detected product page');
                handleProductPage();
            } else {
                log('Not a campaign or product page');
            }

        } catch (error) {
            log('Error in initialization', {error: error.message, stack: error.stack});
        }
    }

    window.feUtils.waitForConditions({
        conditions: ['body', () => {
            return window.FEi18n?.isReady();
        }],
        activity: feProjectId,
        callback: init
    });

})();
